import { PriceItem } from '@app/orders/cod-total/price-item.model';
export class OrderCalculatedPrices {
  object: string;
  PriceItems: Array<PriceItem>;
}

export enum OrderCalculatedPricesDescriptors {
  Total = 'Total',
  SubTotal = 'Sub Total',
  Tax = 'Tax'
}
